import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {dateFormatter} from 'shared/tools';
import {formatCurrency} from 'shared/core';
import {AttachedDocument} from 'main/stores/documents';

class Expense extends DomainObject {
  id;
  title;
  amount;
  date;
  category;
  note;
  nmbrLineItemId;
  nmbrPresetId;
  receipts = [];

  _relations = {
    receipts: [AttachedDocument]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      title: observable,
      amount: observable,
      date: observable,
      category: observable,
      note: observable,
      nmbrLineItemId: observable,
      nmbrPresetId: observable,
      receipts: observable,
      dateView: computed,
      amountView: computed
    });

    this.merge(other);
  }

  get dateView() {
    return dateFormatter(this.date);
  }

  get amountView() {
    return formatCurrency('CAD', this.amount);
  }
}

export default Expense;
